import { action, computed, makeObservable, observable } from 'mobx'

export const ApiOpState = {
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  FAILED: 'failed',
}

/**
 * Holds and mutates common properties and value objects of API operation
 */
class ApiStatusStore {
  static OP_STATE = ApiOpState

  /** @type {typeof ApiOpState[keyof typeof ApiOpState] | undefined} */
  @observable loadState
  /** @type {string | undefined} */
  @observable loadError

  /** @type {typeof ApiOpState[keyof typeof ApiOpState] | undefined} */
  @observable saveState
  /** @type {string | undefined} */
  @observable saveError

  /** @type {typeof ApiOpState[keyof typeof ApiOpState] | undefined} */
  @observable deleteState
  /** @type {string | undefined} */
  @observable deleteError

  @observable remoteErrors

  constructor () {
    makeObservable(this)
  }

  @action.bound
  reset () {
    this.loadState = undefined
    this.loadError = undefined
    this.saveState = undefined
    this.saveError = undefined
    this.deleteState = undefined
    this.deleteError = undefined
    this.remoteErrors = undefined
  }

  @action.bound
  startLoad () {
    this.loadError = undefined
    this.loadState = ApiOpState.IN_PROGRESS
  }

  @action.bound
  finishLoad () {
    this.loadState = ApiOpState.COMPLETED
  }

  @action.bound
  failLoad (error) {
    this.loadError = error
    this.loadState = ApiOpState.FAILED
  }

  @action.bound
  startSave () {
    this.saveError = undefined
    this.remoteErrors = undefined
    this.saveState = ApiOpState.IN_PROGRESS
  }

  @action.bound
  finishSave () {
    this.saveState = ApiOpState.COMPLETED
  }

  @action.bound
  failSave (error) {
    this.saveError = error
    this.saveState = ApiOpState.FAILED
  }

  @action.bound
  startDelete () {
    this.deleteError = undefined
    this.deleteState = ApiOpState.IN_PROGRESS
  }

  @action.bound
  finishDelete () {
    this.deleteState = ApiOpState.COMPLETED
  }

  @action.bound
  failDelete (error) {
    this.deleteError = error
    this.deleteState = ApiOpState.FAILED
  }

  @action.bound
  setRemoteErrors (value) {
    this.remoteErrors = value
  }

  @computed get isSaving () {
    return this.saveState === ApiOpState.IN_PROGRESS
  }

  @computed get isDeleting () {
    return this.deleteState === ApiOpState.IN_PROGRESS
  }

  @computed get isLoading () {
    return this.loadState === ApiOpState.IN_PROGRESS
  }

  @computed get isLoaded () {
    return this.loadState === ApiOpState.COMPLETED
  }
}

export default ApiStatusStore
